import I18n from 'I18n';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CitationButtonAsLink = ({
  source,
  browserWindowHeight,
  navigateToKnowledgeBaseArticle
}) => {
  return /*#__PURE__*/_jsx("button", {
    onClick: () => {
      navigateToKnowledgeBaseArticle({
        deepLink: source.deepLink,
        hubSpotContentId: source.hubSpotContentId,
        hubSpotContentTextFragment: source.hubSpotContentTextFragment
      }, browserWindowHeight, {
        view: 'thread-view'
      });
    },
    children: I18n.text('conversations-visitor-message-history.viewSource')
  });
};
CitationButtonAsLink.displayName = 'CitationButtonAsLink';
export const CitationModalContent = (source, browserWindowHeight, navigateToKnowledgeBaseArticle) => {
  if (source.hubSpotContentType === 'KB_ARTICLE' && typeof navigateToKnowledgeBaseArticle === 'function') {
    return {
      headerContent: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: source.title
        }), /*#__PURE__*/_jsx(CitationButtonAsLink, {
          source: source,
          browserWindowHeight: browserWindowHeight,
          navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle
        })]
      }),
      bodyContent: /*#__PURE__*/_jsx("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: formatHtml(source.richText)
        }
      })
    };
  } else {
    return {
      headerContent: /*#__PURE__*/_jsx("div", {
        children: source.title
      }),
      bodyContent: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("a", {
          href: source.url,
          target: "_blank",
          rel: "noopener noreferrer",
          children: source.url
        })
      })
    };
  }
};
CitationModalContent.displayName = 'CitationModalContent';